<!-- 收集试用报告 -->
<template>
  <div class="content">
    <span v-if="isShowAddBtn">
      <jd-button
        type="blue"
        @click="openQuestion"
        v-if="!isReadOnly && !isStart"
        >添加题目</jd-button
      >
      <jd-button disabled type="blue" v-else>添加题目</jd-button>
      （{{ form.length }}/{{ limitNum }}）
    </span>

    <jd-table v-if="form.length > 0" :tableData="form" style="margin-top: 10px">
      <el-table-column
        label="排序"
        width="100"
        header-align="left"
        v-if="isShowAddBtn"
      >
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="题目类型" width="100">
        <template slot-scope="scope">
          {{ questionType(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column label="是否必填" width="100">
        <template slot-scope="scope">
          {{ questionRequire(scope.row.isMust) }}
        </template>
      </el-table-column>
      <el-table-column label="题目名称（50个字以内）" width="360">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column label="题目内容" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.type <= 2 || [9,10,11,12].includes(scope.row.type)">
            <div
              v-for="(item, index) in getNowOption(
                scope.row.options,
                scope.$index
              )"
              :key="item.id"
              class="option-text"
            >
              <div v-if="scope.row.type == 12">
                {{ item.description }}={{ item.score }}
              </div>
              <template v-else>
                {{ optionTitle(index) }}.{{ item.description }}
                <span v-if="scope.row.type == 9">({{ item.typeName }})</span>
              </template>
            </div>
            <jd-button
              v-if="scope.row.options && scope.row.options.length > 3"
              type="blueText"
              @click="showAllOptions(scope.row, scope.$index)"
            >
              {{ "查看全部" }}
            </jd-button>
          </div>
          <div v-else-if="scope.row.type == 3">
            请输入内容，不少于{{ scope.row.textLimit }}个字
          </div>
          <div v-else-if="scope.row.type == 4 || scope.row.type == 5">
            <div
              class="m_image"
              v-for="(item, index) in scope.row.options"
              :key="item.id"
            >
              {{ optionTitle(index) }}.
              <img :src="item.picUrl" alt="" />
            </div>
          </div>
          <div v-else-if="scope.row.type == 6">
            上传不少于{{ scope.row.picLimit }}张，最多 5张图片
          </div>
          <div v-else-if="scope.row.type == 7">
            <div v-for="(item,i) in getRowDes(scope.row.options)" :key="item.id">
              {{i+1}}.{{ item.rowDescription }}
            </div>
          </div>
          <div v-else-if="scope.row.type == 10">
            <div
              v-for="(item,it) in getMatrixRowDes(scope.row.options)"
              :key="item.id"
            >
              {{it+1}}.{{ item.rowDescription }}({{ item.typeName }})
            </div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="题目交互" width="300" v-if="isShowInteraction">
        <template slot-scope="scope">
          <div v-if="'jumpLogic' in scope.row&&scope.row.jumpLogic!==null">
            <div v-if="scope.row.jumpLogic == 1">
              <template v-if="scope.row.jumpSort == -1">
                <span>完成时结束作答</span>
              </template>
              <template v-else>
                <span>完成时跳转到</span>
                <template>
                  <span v-if="scope.row.jumpSort"
                    >第{{ scope.row.jumpSort }}题</span
                  >
                  <span v-else>最后一题</span>
                </template>
              </template>
            </div>
            <div v-if="!scope.row.interactionType">
              <div v-if="scope.row.jumpLogic == 0">
                <!-- 单选 -->
                <div v-if="scope.row.type == 1 || scope.row.type == 9 || scope.row.type == 12">
                  <div v-for="(item, index) in scope.row.options" :key="index">
                    <template v-if="'jumpSort' in item && item.jumpSort != null">
                      <!-- 不填后面所有题目，结束答题 -->
                      <template v-if="item.jumpSort == -1">
                        <span
                          >选择（题目{{ scope.$index + 1 }}-{{
                            scope.row.type == 12
                              ? item.description
                              : optionTitle(index)
                          }}）不填后面题目，结束答题</span
                        >
                      </template>
                      <template v-else>
                        <span v-if="scope.row.type == 12">{{ item.description }}</span>
                        <span v-else>选项{{ optionTitle(index) }}</span>
                        <span style="margin: 0 12px">-></span>
                        <span>跳转到</span>
                        <template>
                          <span v-if="item.jumpSort">第{{ item.jumpSort }}题</span>
                          <span v-else>最后一题</span>
                        </template>
                      </template>
                    </template>
                  </div>
                </div>
          
                <div v-if="scope.row.type==7||scope.row.type==10">
                  <div v-for="(row, index) in scope.row.options" :key="index">
                    <template v-if="'jumpSort' in row && row.jumpSort != null">
                      <span >选择{{ getTitle(row) }}</span>
                      <!-- 不填后面所有题目，结束答题 -->
                      <span v-if="row.jumpSort == -1">不填后面题目，结束答题</span>
                      <template v-else>
                        <span>跳转到</span>
                        <span v-if="row.jumpSort">第{{ row.jumpSort }}题</span>
                        <span v-else>最后一题</span>
                      </template>
                    </template>
                  </div>
                </div>
                <!-- 多选 -->
                <div v-if="scope.row.type == 2">
                  <span>选择</span>
                  <span>{{
                    scope.row.jumpCondition ? "全部选项" : "任意选项"
                  }}</span>
                  <span>（</span>
                  <template>
                    <span
                      v-for="(item, index) in scope.row.jumpOptionsList"
                      :key="index"
                      >选项{{ optionTitle(item)
                      }}{{
                        index + 1 < scope.row.jumpOptionsList.length ? "、" : ""
                      }}</span
                    >
                  </template>
                  <span>）</span>
                  <!-- 不填后面所有题目，结束答题 -->
                  <span v-if="scope.row.jumpSort == -1">不填后面题目，结束答题</span>
                  <template v-else>
                    <span>跳转到</span>
                    <template>
                      <span v-if="scope.row.jumpSort"
                        >第{{ scope.row.jumpSort }}题</span
                      >
                      <span v-else>最后一题</span>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-if="scope.row.showSort">选中(第{{scope.row.showSort}}题中的{{ getOptions(scope.row) }})显示当前题目</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作（题目修改、删除、移动时会移除全部题目交互）"
        min-width="250"
      >
        <template slot-scope="scope">
          <jd-button
            type="blueText"
            @click="editQuestion(scope.row, scope.$index)"
            v-if="!isReadOnly && !isStart"
            :disabled="!(!isReadOnly && !isStart)"
            >{{ actionText }}</jd-button
          >
          <jd-button
            type="blueText"
            @click="deleteQuestion(scope.$index)"
            v-if="isShowAddBtn && !isReadOnly && !isStart"
            :disabled="!(!isReadOnly && !isStart)"
            >删除</jd-button
          >
          <jd-button
            type="blueText"
            @click="showSkip(scope.row, scope.$index)"
            v-if="isShowAddBtn && !isReadOnly && !isStart"
            :disabled="!(!isReadOnly && !isStart)"
            >题目交互</jd-button
          >
          <jd-button
            type="blueText"
            @click="upSet(scope.$index)"
            v-if="scope.$index !== 0 && !isReadOnly && !isStart"
            :disabled="scope.$index == 0"
            >上移</jd-button
          >
          <jd-button
            type="blueText"
            @click="downSet(scope.$index)"
            v-if="scope.$index !== form.length - 1 && !isReadOnly && !isStart"
            :disabled="scope.$index == form.length - 1"
            >下移</jd-button
          >
        </template>
      </el-table-column>
    </jd-table>

    <addQuestion
      :visible.sync="isDialogVisible"
      :isEdit="question.isEdit"
      :onlyShow="question.onlyShow"
      :currentQuestion="question.currentQuestion"
      @reset-only-show="resetOnlyShow"
      @confirm="handleConfirm"
      @close="handleClose"
      :isShowCheckInput="isShowCheckInput"
      :isShowCheckInput2="isShowCheckInput2"
    ></addQuestion>

    <!-- 跳题 -->
    <jdDialog
      title="题目交互"
      :visible.sync="skipVisible"
      @close="dialogClose"
      @confirm="dialogConfirm"
      width="700px"
    >
      <el-form>
        <el-form-item label="交互类型：">
          <el-radio-group
            v-model="skipForm.interactionType"
            @input="interactionClick"
          >
            <el-radio :disabled="skipDisabled" :label="0">跳题</el-radio>
            <el-radio :disabled="skipIndex == 0||hideOptions.length==0" :label="1"
              >本题默认隐藏，仅选择指定题目答案才会显示</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="跳题逻辑："
          v-if="skipForm.interactionType == 0 && !isMatrixShow&&!skipDisabled"
        >
          <el-radio-group v-model="skipForm.jumpLogic" @input="jumpLogicClick">
            <el-radio :label="0">按选项跳题</el-radio>
            <el-radio :label="1">无条件跳题</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="option" v-if="skipForm.interactionType == 0&&!skipDisabled">
        <!-- 按选项跳题 -->
        <div v-if="skipForm.type != 7 && skipForm.type != 10">
          <template v-if="skipForm.jumpLogic == 0">
            <!-- 单选题 -->
            <div v-if="[1,9,12].includes(skipForm.type)">
              <span class="option_title">{{ skipForm.type == 1 ?  '单选题' : skipForm.type == 12 ? '量表题' : '多类型选择题' }}</span>
              <jdTable
                :tableData="skipForm.options"
                :tableInfo="newOptionTableInfo"
              >
                <template #jumpType="scope">
                  <el-select
                    v-model="scope.row.jumpSort"
                    placeholder="请选择跳转位置"
                  >
                    <el-option
                      v-for="item in optionSelect"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </template>
              </jdTable>
            </div>
            <!-- 多选题 -->
            <div v-else>
              <el-form label-width="70px">
                <el-form-item label="当用户">
                  <el-select
                    v-model="skipForm.jumpCondition"
                    placeholder="请选择"
                    style="margin-right: 8px"
                  >
                    <el-option label="选择任一选项" :value="0"> </el-option>
                    <el-option label="选择全部选项" :value="1"> </el-option>
                  </el-select>
                  <el-select
                    v-model="skipForm.jumpOptionsList"
                    multiple
                    collapse-tags
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in skipForm.options"
                      :key="index"
                      :label="item.description"
                      :value="index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="跳转位置">
                  <el-select
                    v-model="skipForm.jumpSort"
                    placeholder="请选择跳转位置"
                  >
                    <el-option
                      v-for="item in optionSelect"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
          </template>
          <!-- 无条件跳题 -->
          <template v-else>
            <div>
              <el-form>
                <el-form-item label="填写此题后跳转到：">
                  <el-select
                    v-model="skipForm.jumpSort"
                    placeholder="请选择跳转位置"
                  >
                    <el-option
                      v-for="item in optionSelect"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
          </template>
        </div>
        <div class="option" v-else>
          <el-form-item label="选择题目：">
            <el-select
              v-model="selectedQuestion"
              placeholder="请选择"
              @change="selectMatrixRows"
            >
              <el-option
                v-for="(item, index) in matrixRows"
                :key="index"
                :label="item.description"
                :value="item.sort"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选中选项：">
            <el-select
              v-model="selectedValue"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in matrixColumn"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跳转至：">
            <el-select
              v-model="skipForm.jumpSort"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in selectMatrixOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="option" v-else-if="skipForm.interactionType == 1">
        <el-form-item label="选择题目：">
          <el-select
            v-model="skipForm.showSort"
            placeholder="请选择"
            @change="selectHideOptions"
          >
            <el-option
              v-for="(item, index) in hideOptions"
              :key="index"
              :label="item.title"
              :value="item.sort"
            >
            </el-option>
          </el-select>
          <span class="m8">中</span>
          <el-select
            v-model="skipForm.showOptionsList"
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in selectOptions"
              :key="index"
              :label="item.description"
              :value="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </jdDialog>
  </div>
</template>

<script>
// 参考收集使用报告组件写的
import addQuestion from "./addTopic.vue";
export default {
  components: {
    addQuestion,
  },
  props: {
    // 回显的数据
    questions: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      // 只读
      type: Boolean,
      default: false,
    },
    isStart: {
      // 活动是否在进行中
      type: Boolean,
      default: false,
    },
    labelWidth: {
      // 表单label宽度
      type: String,
      default: "80px",
    },
    labelName: {
      // 表单label名称
      type: String,
      default: "设置题目",
    },
    limitNum: {
      type: Number,
      default: 50,
    },
    // 控制添加按钮显示
    isShowAddBtn: {
      type: Boolean,
      default: true,
    },
    actionText: {
      type: String,
      default: "修改",
    },
    // 单选题-是否需要输入自定义内容（调查问卷）
    isShowCheckInput: {
      type: Boolean,
      default: false,
    },
    // 多选题-是否需要输入自定义内容（调查问卷）
    isShowCheckInput2: {
      type: Boolean,
      default: false,
    },
    isShowInteraction: {
      type: Boolean,
      default: true,
    }
  },
  mounted() {
    if (this.questions.length > 0) {
      this.form = JSON.parse(JSON.stringify(this.questions));
      console.log("---  this.questions:---", this.questions);
    }
  },
  watch: {
    questions: {
      handler(val) {
        if (val.length > 0) {
          this.form = JSON.parse(JSON.stringify(val));
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      selectedQuestion: null,
      selectedValue: null,
      selectMatrixOptions: [],
      totalMatrixColumn: [], //总的多类型矩阵题列选项名称
      matrixRows: [], //多类型矩阵题行题目名称
      matrixColumn: [], //多类型矩阵题列选项名称
      selectOptions: [], // 当前选中的题目选项
      hideOptions: [], // 隐藏题目前面的数据
      isDialogVisible: false, // 控制弹窗显示/隐藏
      question: {
        // 回显的数据
        index: null, // 回显的数据下标
        isEdit: false, // 是否在编辑状态
        onlyShow: false, // 仅查看
        currentQuestion: {}, // 回显的问题
      },
      // 表单数据
      form: [],
      // 跳题
      skipVisible: false,
      skipForm: {},
      skipIndex: 0,
      optionTableInfo: [
        {
          prop: "description",
          label: "选项名称",
        },
        {
          slot: "jumpType",
          label: "跳转位置",
        },
      ],
      optionTableInfo1: [
      {
          prop: "typeName",
          label: "类型",
        },
        {
          prop: "description",
          label: "选项名称",
        },
        {
          slot: "jumpType",
          label: "跳转位置",
        },
      ],
      // 跳转位置下拉选项：-1=不填后面所有题目，结束答题；0=跳至最后一题（固定）；其余为后续题目序号
      optionSelect: [
        {
          value: -1,
          label: "不填后面所有题目，结束答题",
        },
        {
          value: 0,
          label: "跳至最后一题",
        },
      ],
    };
  },
  computed: {
    // 跳题是否禁用
    skipDisabled() {
      const typeList = [3, 4, 5,6, 8, 11];
      return typeList.includes(this.skipForm.type);
    },
    isMatrixShow() {
      return this.skipForm.type == 7 || this.skipForm.type == 10;
    },
    newOptionTableInfo() {
      return this.skipForm.type == 1 || this.skipForm.type == 12 ? this.optionTableInfo : this.optionTableInfo1
    },
  },
  methods: {
    selectMatrixRows(e) {
      this.selectedValue = null
      this.matrixColumn = []
      this.matrixColumn = this.totalMatrixColumn.filter((item) => {
        return item.sort == e;
      }).map((item)=>{
        return {
          ...item,
          value: item.level,
          label: item.description.split(":")[1],
        }
      });
    },
    // 处理题目交互数据
    getData(row,index) {
      if (this.skipDisabled) {
        this.skipForm.interactionType = 1;
      }
      if (index == 0) {
        this.skipForm.interactionType = 0;
      }
      this.form = this.form.map((item,index)=>{
        return {...item,sort: index+1}
      })
      // 获取多类型矩阵题数据
      // this.matrixColumnoptions
      if (this.skipForm.type == 7 || this.skipForm.type == 10) {
        const rowsArr = this.getMatrixRowDes(this.form[index].options);
        this.matrixRows = rowsArr.map((item) => {
          return { ...item, description: item.rowDescription };
        });
        this.totalMatrixColumn = this.form[index].options
        let selectMatrixOptions = this.form.slice(index+1);
        this.selectMatrixOptions = selectMatrixOptions.map((item, inde) => {
          return {
            ...item,
            value: index + 1 + inde + 1,
            label: item.title,
          };
        });
        this.selectMatrixOptions.unshift({
          value: 0,
          label: "跳至最后一题",
        });
        this.selectMatrixOptions.unshift({
          value: -1,
          label: "不填后面所有题目，结束答题",
        });
        row.options.forEach((item) => {
          if ("jumpSort" in item&&item.jumpSort!=null) {
            this.selectMatrixRows(item.sort)
            this.selectedQuestion = item.sort
            this.selectedValue = item.level
          }
        });
      }
      // 获取显题数据
      const arr = this.form.slice(0, index);
        if (arr.length > 0) {
          this.hideOptions = arr.filter((item) => {
            return item.type == 1 || item.type == 2 || item.type == 12;
          });
        }
      if(this.skipForm.interactionType==1) {
        if(this.skipForm.showSort) {
          this.selectOptions = this.hideOptions.filter((item) => {
            return item.sort == this.skipForm.showSort;
          })[0].options
        }
      }
    },
    selectHideOptions(e) {
      this.selectOptions = this.hideOptions.filter((item) => {
        return item.sort == e;
      })[0].options
      this.skipForm.showOptionsList = [];
    },
    interactionClick(e) {
      console.log(this.skipForm,'65656');
      if ("showSort" in this.skipForm) {
          delete this.skipForm.showSort;
      }
      if ("showOptionsList" in this.skipForm) {
        delete this.skipForm.showOptionsList;
      }
      if ("jumpLogic" in this.skipForm) {
        delete this.skipForm.jumpLogic;
      }
      if ("jumpSort" in this.skipForm) {
        delete this.skipForm.jumpSort;
      }
      if ("jumpOptionsList" in this.skipForm) {
        delete this.skipForm.jumpOptionsList;
      }
      if ("jumpCondition" in this.skipForm) {
        delete this.skipForm.jumpCondition;
      }
      this.$set(this.skipForm,'jumpOptionsList',[])
      if(e==0) {
        this.$set(this.skipForm,'jumpLogic',0)
        this.skipForm.options.forEach((item) => {
          if ("jumpSort" in item&&item.jumpSort!=null) {
           delete item.jumpSort
          }
        })
      } else {
        this.$set(this.skipForm,'showSort',null)
      }
    },
    // 显示跳题
    showSkip(row, index) {
      console.log(row);
      // 判断index是否是form的最后一题 如果是则输出空数组 如果不是则输出后面的所有题目
      if (index == this.form.length - 1) {
        this.optionSelect = [];
      } else {
        let arr = this.form.slice(index + 1);
        this.optionSelect = arr.map((item, inde) => {
          return {
            value: index + 1 + inde + 1,
            label: item.title,
          };
        });
      }
      // 在optionSelect第一位push进一个对象
      this.optionSelect.unshift({
        value: 0,
        label: "跳至最后一题",
      });
      this.optionSelect.unshift({
        value: -1,
        label: "不填后面所有题目，结束答题",
      });
      if ("interactionType" in row&&row.interactionType!==null) {
        this.skipForm = JSON.parse(JSON.stringify(row));
        if(!("jumpLogic" in row)&&row.interactionType==0) {
          this.$set(this.skipForm,'jumpLogic',0)
        }
      } else if ("jumpLogic" in row&&row.jumpLogic!==null) {
        this.skipForm = JSON.parse(JSON.stringify(row));
      } else {
        let newRow = JSON.parse(JSON.stringify(row));
        this.skipForm = {
          ...newRow,
          jumpLogic: 0,
          interactionType: 0,
        };
        // 单选添加
        if (this.skipForm.type == 1 || this.skipForm.type == 12) {
          // 在skipForm.options 每个对象添加jumpType属性
          let newoptions = this.skipForm.options.map((item) => {
            return {
              ...item,
            };
          });
          this.skipForm.options = newoptions;
        }
      }
      console.log(this.skipForm,'56464');
      this.getData(row,index);
      this.skipIndex = index;
      this.skipVisible = true;
    },
    // 跳转逻辑点击
    jumpLogicClick(e) {
      // 切换逻辑清空数据
      if (e == 0) {
        // 切换到按选项跳题
        // 判断skipForm是否有jumpSort 如果有则删除
        if ("jumpSort" in this.skipForm) {
          delete this.skipForm.jumpSort;
        }
      } else {
        // 切换到无条件跳题
        if (this.skipForm.type == 1 || this.skipForm.type == 12) {
          // 单选
          // 遍历skipForm.options 判断里面是否存在jumpSort 如果有则删除
          this.skipForm.options.forEach((item) => {
            if ("jumpSort" in item) {
              delete item.jumpSort;
            }
          });
        } else {
          // 多选
          // 判断skipForm是否有jumpCondition 如果有则删除
          if ("jumpCondition" in this.skipForm) {
            delete this.skipForm.jumpCondition;
          }
          // 判断skipForm是否有jumpOptionsLits 如果有则删除
          if ("jumpOptionsList" in this.skipForm) {
            delete this.skipForm.jumpOptionsList;
          }
          // 判断skipForm是否有jumpSort 如果有则删除
          if ("jumpSort" in this.skipForm) {
            delete this.skipForm.jumpSort;
          }
          console.log(this.skipForm, "this.skipForm");
        }
      }
    },
    // 弹窗关闭
    dialogClose() {
      this.skipForm = {};
      this.skipIndex = null;
      this.optionSelect = [];
      this.hideOptions = [];
      this.selectOptions = [];
      this.matrixColumn = []
      this.skipVisible = false;
      this.$emit("collectQuestion", this.form);
      this.$forceUpdate();
    },
    // 跳题设置确认
    dialogConfirm() {
      console.log(this.skipForm,'this.211skipForm');
      // 第一层跳题逻辑判断
      if(this.skipForm.interactionType==0) {
        if (this.skipForm.jumpLogic == 0) {
          // 按选项跳题
          if ([1,9,12].includes(this.skipForm.type) || this.isMatrixShow) {
            // 单选
            // 遍历skipForm.options 判断是否至少有一个item里面存在有jumpSort
            let isJumpSort = this.skipForm.options.some((item) => {
              return "jumpSort" in item;
            });
            if (!isJumpSort&&!this.isMatrixShow) {
              this.$message.warning("请为选项添加跳转位置");
              return;
            }
            if(this.isMatrixShow) {
              if (!("jumpSort" in this.skipForm)) {
                this.$message.warning("请选择跳转位置");
                return;
              }
              // 新增：检查目标题目是否为显题
              const targetQuestion = this.form.find(q => q.sort === this.skipForm.jumpSort);
              if (targetQuestion && targetQuestion.interactionType === 1) {
                this.$message.warning("该题为默认隐藏题，不支持跳到该题位置");
                return;
              }
              this.$set(
                this.form[this.skipIndex],
                "jumpSort",
                this.skipForm.jumpSort
              );
              this.form[this.skipIndex].options.forEach((item) => {
                if ("jumpSort" in item) {
                  delete item.jumpSort;
                }
              });
              this.form[this.skipIndex].options.forEach((item) => {
                if(item.sort==this.selectedQuestion&&item.level==this.selectedValue) {
                  this.$set(
                    item,
                    "jumpSort",
                    this.skipForm.jumpSort
                  );
                }
              })
            }
            // 新增：检查选项中的跳转目标是否为显题
            if(!this.isMatrixShow && this.skipForm.options) {
              for(let item of this.skipForm.options) {
                if("jumpSort" in item) {
                  const targetQuestion = this.form.find(q => q.sort === item.jumpSort);
                  if (targetQuestion && targetQuestion.interactionType === 1) {
                    this.$message.warning("选项中包含跳转到默认隐藏题的设置，不支持跳到该题位置");
                    return;
                  }
                }
              }
            }
            // 数组赋值
            // 使用set方法添加属性
            this.$set(
              this.form[this.skipIndex],
              "jumpLogic",
              this.skipForm.jumpLogic
            );
            this.$set(
              this.form[this.skipIndex],
              "interactionType",
              this.skipForm.interactionType
            );
            if(!this.isMatrixShow) {
              this.$set(
                this.form[this.skipIndex],
                "options",
                this.skipForm.options
              );
            }
            this.dialogClose();
          } else {
            // 多选
            if (!("jumpCondition" in this.skipForm)) {
              this.$message.warning("请正确选择触发跳题逻辑！");
              return;
            }
            if (!this.skipForm.jumpOptionsList.length) {
              this.$message.warning("请正确选择触发跳题逻辑！");
              return;
            }
            if (!("jumpSort" in this.skipForm)) {
              this.$message.warning("请选择跳转位置");
              return;
            }
            // 新增：检查目标题目是否为显题
            const targetQuestion = this.form.find(q => ((q.sort === this.skipForm.jumpSort)||(this.skipForm.jumpSort==0&&q.sort==this.form.length)));
            if (targetQuestion && targetQuestion.interactionType === 1) {
              this.$message.warning("该题为默认隐藏题，不支持跳到该题位置");
              return;
            }
            // 使用set方法添加属性
            this.$set(
              this.form[this.skipIndex],
              "jumpLogic",
              this.skipForm.jumpLogic
            );
            this.$set(
              this.form[this.skipIndex],
              "interactionType",
              this.skipForm.interactionType
            );
            this.$set(
              this.form[this.skipIndex],
              "jumpCondition",
              this.skipForm.jumpCondition
            );
            this.$set(
              this.form[this.skipIndex],
              "jumpOptionsList",
              this.skipForm.jumpOptionsList
            );
            this.$set(
              this.form[this.skipIndex],
              "jumpSort",
              this.skipForm.jumpSort
            );
            this.dialogClose();
          }
        } else {
          // 无条件跳题
          if ("jumpSort" in this.skipForm) {
            if (this.skipForm.type == 1 || this.skipForm.type == 12) {
              // 单选
              this.$set(
                this.form[this.skipIndex],
                "options",
                this.skipForm.options
              );
              this.$set(
                this.form[this.skipIndex],
                "jumpLogic",
                this.skipForm.jumpLogic
              );
              this.$set(
                this.form[this.skipIndex],
                "jumpSort",
                this.skipForm.jumpSort
              );
            } else {
              // 多选
              // 多余数据清空 确保this.form[this.skipIndex]等于this.skipForm
              for (const key in this.form[this.skipIndex]) {
                if (!(key in this.skipForm)) {
                  delete this.form[this.skipIndex][key];
                } else {
                  this.$set(this.form[this.skipIndex], key, this.skipForm[key]);
                }
              }
              // 二次赋值
              for (const key in this.skipForm) {
                if (!(key in this.form[this.skipIndex])) {
                  this.$set(this.form[this.skipIndex], key, this.skipForm[key]);
                }
              }
            }
            this.dialogClose();
          } else {
            this.$message.warning("请选择跳转位置");
            return;
          }
        }
      } else {
           // 新增：检查是否有其他题目设置了跳转到当前题目
          const currentQuestionSort = this.skipForm.sort;
          let hasJumpToCurrentQuestion = false;
          
        // 遍历所有题目，检查是否有跳转到当前题目的设置
        for(let i = 0; i < this.form.length; i++) {
          if(i === this.skipIndex) continue; // 跳过当前题目
          
          const question = this.form[i];
          
          // 检查无条件跳题
          if(question.jumpLogic === 1 && question.jumpSort === currentQuestionSort) {
            hasJumpToCurrentQuestion = true;
            break;
          }
          
          // 检查按选项跳题（单选）
          if(question.type === 1 && question.options) {
            const hasJumpOption = question.options.some(item => 
              item.jumpSort === currentQuestionSort
            );
            if(hasJumpOption) {
              hasJumpToCurrentQuestion = true;
              break;
            }
          }
          
          // 检查按选项跳题（多选）
          if((question.jumpLogic === 0 && question.jumpSort === currentQuestionSort) ||(question.jumpSort==0&&currentQuestionSort==this.form.length)) {
            hasJumpToCurrentQuestion = true;
            break;
          }
        }
        
        // 如果有其他题目跳转到当前题目，则阻止设置显题
        if(hasJumpToCurrentQuestion) {
          this.$message.warning('该题目已被配置为跳题目标，不支持配置显题逻辑！');
          return;
        }
        if (!("showSort" in this.skipForm)) {
          this.$message.warning("请选择指定题目");
          return;
        }
        if (!this.skipForm.showOptionsList.length) {
          this.$message.warning("请选择指定题目答案！");
          return;
        }
        this.$set(
          this.form[this.skipIndex],
          "showSort",
          this.skipForm.showSort
        );
        this.$set(
          this.form[this.skipIndex],
          "interactionType",
          this.skipForm.interactionType
        );

        this.$set(
          this.form[this.skipIndex],
          "showOptionsList",
          this.skipForm.showOptionsList
        );
        this.$set(
          this.form[this.skipIndex],
          "jumpLogic",
          null
        );
        this.dialogClose();
      }
    },
    // 清空跳题逻辑
    clearJumpLogic(data) {
      let row = JSON.parse(JSON.stringify(data));
      console.log(row,'4344344');
      // 判断skipForm是否有jumpSort 如果有则删除
      if ("jumpSort" in row) {
        delete row.jumpSort;
      }
      // 判断skipForm是否有jumpSort 如果有则删除
      if ("jumpLogic" in row) {
        delete row.jumpLogic;
      }
      // 多选
      if ("jumpCondition" in row) {
        delete row.jumpCondition;
      }
      // 判断skipForm是否有jumpOptionsLits 如果有则删除
      if ("jumpOptionsList" in row) {
        delete row.jumpOptionsList;
      }

      if ("showSort" in row) {
        delete row.showSort;
      }

      if ("showOptionsList" in row) {
        delete row.showOptionsList;
      }
      
      if (data.type == 1||data.type == 7||data.type == 9||data.type == 10) {
        // 单选
        // 遍历options 判断里面是否存在jumpSort 如果有则删除
        row.options.forEach((item) => {
          if ("jumpSort" in item) {
            delete item.jumpSort;
          }
        });
      }
      return row;
    },
    // 下移
    downSet(index) {
      this.form.forEach((item, index) => {
        this.form[index] = this.clearJumpLogic(item);
      });
      this.$forceUpdate();
      if (index < this.form.length - 1) {
        const temp = this.form[index];
        this.form.splice(index, 1, this.form[index + 1]);
        this.form.splice(index + 1, 1, temp);
        this.$emit("collectQuestion", this.form);
      }
      this.form = this.form.map((item,index)=>{
        return {...item,sort: index+1}
      })
    },
    // 上移
    upSet(index) {
      this.form.forEach((item, index) => {
        this.form[index] = this.clearJumpLogic(item);
      });
      this.$forceUpdate();
      if (index !== 0) {
        const temp = this.form[index];
        this.form.splice(index, 1, this.form[index - 1]);
        this.form.splice(index - 1, 1, temp);
        this.$emit("collectQuestion", this.form);
      }
      this.form = this.form.map((item,index)=>{
        return {...item,sort: index+1}
      })
    },
    // 修改题目
    editQuestion(item, index) {
      this.question.currentQuestion = item;
      this.question.index = index;
      this.question.isEdit = true;
      this.isDialogVisible = true;
    },
    // 删除题目
    deleteQuestion(index) {
      this.form.splice(index, 1);
      this.$emit("collectQuestion", this.form);
      this.form.forEach((item, index) => {
        if (item.type == 1 || item.type == 2) {
          this.form[index] = this.clearJumpLogic(item);
        }
      });
      // console.log("--- this.form:---", this.form)
    },
    // 打开添加题目弹窗
    openQuestion() {
      if (this.form.length >= this.limitNum) {
        this.$message.warning(`最多只能添加${this.limitNum}个题目`);
        return;
      }
      this.isDialogVisible = true;
    },
    // 题目类型
    questionType(type) {
      const typeMap = {
        1: "单选题",
        2: "多选题",
        3: "填空题",
        4: "图片单选题",
        5: "图片多选题",
        6: "图片上传题",
        7: "矩阵题",
        8: "手机号",
        9: "多类型选择题",
        10: "多类型矩阵题",
        11: "多题填空",
        12: "量表题"
      };
      return typeMap[type] || "";
    },
    // 是否必填
    questionRequire(val) {
      if (val.toString() == "0") {
        return "否";
      } else if (val.toString() == "1") {
        return "是";
      }
    },
    // 根据 index获取选项名称
    optionTitle(index) {
      switch (index) {
        case 0:
          return "A";
        case 1:
          return "B";
        case 2:
          return "C";
        case 3:
          return "D";
        case 4:
          return "E";
        case 5:
          return "F";
        case 6:
          return "G";
        case 7:
          return "H";
        case 8:
          return "I";
        case 9:
          return "J";
        case 10:
          return "K";
        case 11:
          return "L";
        case 12:
          return "M";
        case 13:
          return "N";
        case 14:
          return "O";
        case 15:
          return "P";
        case 16:
          return "Q";
        case 17:
          return "R";
        case 18:
          return "S";
        case 19:
          return "T";
        default:
          return "";
      }
    },
    getTitle(item) {
      let text = `（题目${item.sort+1}-${item.description.split(":")[1]}）`
      return text
    },
    getOptions(item) {
      return item.showOptionsList.map((item)=>{
        return '选项'+this.optionTitle(item)
      }).join('，')
    },
    // 确认操作
    handleConfirm(data) {
      let index = this.question.index;
      if (this.question.isEdit) {
        // 修改题目
        this.form.splice(index, 1, this.clearJumpLogic(data));
      } else {
        // 新增题目
        this.form.push(data);
      }
      this.question.isEdit = false;
      this.form = this.form.map((item,index)=>{
        return {...item,sort: index+1}
      })
      this.$emit("collectQuestion",this.form);
    },
    // 关闭弹窗
    handleClose() {
      console.log("弹窗已关闭");
      this.question.isEdit = false;
    },

    getRowDes(options) {
      let options10Row = [];
      options.forEach((item) => {
        let options10RowSort = options10Row.map((item1) => item1.sort);
        if (!options10RowSort.includes(item.sort)) {
          let rowObj = {
            rowDescription: item.description.split(":")[0],
            ...item,
          };
          options10Row.push(rowObj);
        }
      });
      options10Row.sort(function (a, b) {
        return a.sort - b.sort;
      });
      return options10Row;
    },
    getMatrixRowDes(options) {
      // 按typeSort对选项进行分组
      const typeMap = {};

      options.forEach((item) => {
        const { typeSort, typeName, sort } = item;
        const rowDescription = item.description.split(":")[0];
        // 确保typeSort存在
        const key = typeSort || 0;

        if (!typeMap[key]) {
          typeMap[key] = {};
        }

        // 按sort值存储行信息，确保每个sort对应唯一的行描述
        if (!typeMap[key][sort]) {
          typeMap[key][sort] = {
            ...item,
            rowDescription: rowDescription,
            typeName: typeName || "",
          };
        }
      });

      // 转换为数组并按typeSort和sort排序
      let options10Row = [];

      // 先按typeSort排序分组
      Object.keys(typeMap)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .forEach((typeSortKey) => {
          const group = typeMap[typeSortKey];

          // 再按sort排序每个分组内的行
          Object.keys(group)
            .sort((a, b) => parseInt(a) - parseInt(b))
            .forEach((sortKey) => {
              options10Row.push(group[sortKey]);
            });
        });

      // 如果没有id属性，添加一个临时id以避免vue警告
      options10Row = options10Row.map((item, index) => ({
        ...item,
        id: item.id || `row_${index}`,
      }));

      return options10Row;
    },
    getMatrixcolumnsDes(options) {
      // 处理矩阵类型的列数据
      if (!options || options.length === 0) {
        return [];
      }

      // 创建一个Map来存储列信息，确保每个level对应唯一的列描述
      const columnsMap = new Map();

      options.forEach((item) => {
        // 从description中提取列描述
        const descriptionParts = item.description.split(":");
        if (descriptionParts && descriptionParts.length >= 2) {
          const columnDescription = descriptionParts[1];
          const level = item.level;

          // 只存储唯一的列信息
          if (level && !columnsMap.has(level)) {
            columnsMap.set(level, {
              ...item,
              columnDescription: columnDescription,
              id: item.id || `column_${level}`,
            });
          }
        }
      });

      // 转换为数组并按level排序
      const columns = Array.from(columnsMap.values()).sort(
        (a, b) => parseInt(a.level) - parseInt(b.level)
      );

      return columns;
    },
    // 获取当前的选项(超过三条进行截取, 点击了展开则显示全部)
    getNowOption(options) {
      if (options && options.length > 3) {
        return options.slice(0, 3);
      }
      return options;
    },
    // 点击查看全部
    showAllOptions(item, index) {
      this.question.currentQuestion = item;
      this.question.index = index;
      this.question.onlyShow = true;
      this.isDialogVisible = true;
    },
    // 重置查看变量
    resetOnlyShow() {
      this.question.onlyShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  // background-color: #f8f9fc;
  // width: 1350px;
  // padding: 20px 0px 20px 24px;
  color: #666666;
  font-size: 14px;

  .flex-1 {
    flex: 1;
  }

  .flex-4 {
    flex: 4;
  }

  .flex-2 {
    flex: 2;
  }

  .h_sort,
  .m_sort {
    padding-left: 34px;
  }

  .questions {
    width: calc(100% - 8px);
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    margin-right: 8px;
    margin-top: 10px;

    .q_head {
      width: 100%;
      background-color: #f0f2f7;
      display: flex;
      align-items: center;
      height: 48px;
    }

    .multiple {
      width: 100%;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f2f2f2;
      padding: 14px 0;

      .m_title {
        .m_text {
          width: 80%;
          line-height: 20px;
        }
      }

      .m_content {
        display: flex;
        flex-direction: column;

        div {
          line-height: 20px;
        }
      }

      .m_operate {
        display: flex;
        align-items: center;
        color: #3158ff;
        gap: 10px;

        span {
          cursor: pointer;
        }

        .disabled {
          color: #c0c4cc;
          cursor: not-allowed;
        }
      }
    }
  }
}

.fill_text {
  width: 80%;
}

.m_image {
  display: flex;
  align-items: center;
  margin-top: 8px;

  img {
    width: 32px;
    height: 32px;
  }
}

.m_image:nth-child(1) {
  margin-top: 0px;
}
/deep/ .el-table .el-table__header-wrapper th .cell {
  text-align: left !important;
  font-weight: 500;
}

.option-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  max-height: 2.8em;
  margin-bottom: 5px;
}
.option {
  background: #f7f8f9;
  padding: 20px;
  .option_title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
}
.m8 {
  margin: 0 8px;
}
</style>
